import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import React from 'react';

interface DialogBaseProps {
  open: boolean;
  title?: string | React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  DialogProps?: Partial<DialogProps>;
  DialogContentStyles?: React.CSSProperties;
}

export const DialogBase = ({
  open,
  title,
  children,
  actions,
  DialogProps = {},
  DialogContentStyles = {}
}: DialogBaseProps) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      {...DialogProps}
    >
      {title && <DialogTitle style={{ textAlign: 'center' }}>{title}</DialogTitle>}

      <DialogContent
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...DialogContentStyles }}
      >
        {children}
      </DialogContent>

      {actions && (
        <DialogActions style={{ justifyContent: 'center' }}>
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};
